// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { LAYOUT } from 'constant/layout.constant'
import { AUTH_MODULE, AUTH_URL } from 'constant/url.constant'

// UI
const { AuthLogin, AuthChangeRole } = lazily(() => import('pages/auth'))

const authRoutes: IRoute[] = [
  {
    path: AUTH_URL.LOGIN,
    component: AuthLogin,
    layout: LAYOUT.AUTH,
    exact: true,
    meta: {
      module: AUTH_MODULE,
      requireAuth: false,
      attrs: {
        label: 'app.login',
        image: 'auth/login',
      },
    },
  },
  {
    path: AUTH_URL.CHANGE_ROLE,
    component: AuthChangeRole,
    layout: LAYOUT.AUTH,
    exact: true,
    meta: {
      module: AUTH_MODULE,
      requireAuth: true,
      attrs: {
        label: 'auth.changeRole.changeRole',
        image: 'auth/login',
      },
    },
  },
  // {
  //   path: '/auth/register',
  //   component: AuthRegister,
  //   layout: LayoutAuth,
  //   exact: true,
  //   meta: {
  //     module: 'auth',
  //     requireAuth: false,
  //     attrs: {
  //       image: 'auth/login',
  //     },
  //   },
  // },
  // {
  //   path: '/auth/reset-password',
  //   component: AuthResetPassword,
  //   layout: LayoutAuth,
  //   exact: true,
  //   meta: {
  //     module: 'auth',
  //     requireAuth: false,
  //     attrs: {
  //       image: 'auth/login',
  //     },
  //   },
  // },
  // {
  //   path: '/auth/otp-verification',
  //   component: AuthOtpVerification,
  //   layout: LayoutAuth,
  //   exact: true,
  //   meta: {
  //     module: 'auth',
  //     requireAuth: false,
  //     attrs: {
  //       image: 'auth/reset-password',
  //     },
  //   },
  // },
  // {
  //   path: '/auth/change-password',
  //   component: AuthChangePassword,
  //   layout: LayoutAuth,
  //   exact: true,
  //   meta: {
  //     module: 'auth',
  //     requireAuth: false,
  //     attrs: {
  //       image: 'auth/reset-password',
  //     },
  //   },
  // },
  // {
  //   path: '/auth/reset-password-success',
  //   component: AuthSuccess,
  //   layout: LayoutAuth,
  //   exact: true,
  //   meta: {
  //     module: 'auth',
  //     requireAuth: false,
  //     attrs: {
  //       image: 'auth/success',
  //       label: 'auth.successResetPassword.label',
  //       subLabel: 'auth.successResetPassword.subLabel',
  //       centeredLayout: true,
  //     },
  //   },
  // },
  // {
  //   path: '/auth/register-success',
  //   component: AuthSuccess,
  //   layout: LayoutAuth,
  //   exact: true,
  //   meta: {
  //     module: 'auth',
  //     requireAuth: false,
  //     attrs: {
  //       image: 'auth/success',
  //       label: 'auth.successRegister.label',
  //       subLabel: 'auth.successRegister.subLabel',
  //       centeredLayout: true,
  //     },
  //   },
  // },
]

export { authRoutes }
